import styles from "./Tab.module.scss";

const Tab = ({ children, title, tabStyles }) => {
  return (
    <div style={tabStyles} className={`${styles.tab}`}>
      {children}
    </div>
  );
};

export default Tab;
